import { gql } from "@apollo/client";

export const GET_ALL_FORMATO_PRESUPUESTO = gql`
query GetAllFormatoPresupuesto {
    allFormatoPresupuesto {
        idFormatoPresupuesto
        descripcion
    }
}
`;

export const adaptFormatoPresupuesto = (formatoPresupuesto) => {
  return {
    id: formatoPresupuesto?.idFormatoPresupuesto,
    displayName: formatoPresupuesto?.descripcion
  };
};

export const adaptFormatoPresupuestoArray = (
allFormatoPresupuesto) =>
{
  return structuredClone(allFormatoPresupuesto)?.
  map((formatoPresupuesto) => adaptFormatoPresupuesto(formatoPresupuesto));
};